import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withRouter, Link } from 'react-router-dom';
import ReactWOW from 'react-wow';

import { Check, X } from 'react-feather';

import {
  Col,
  Media,
  Input,
  Button,
} from 'reactstrap';

import logo_white from '../../../../assets/images/white padding.png';

const pound = `${'\u00A3'}`;

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

class SavingsCalculator extends Component {
  static propTypes = {
  };

  static defaultProps = {
    user: {},
  };

  constructor(props) {
    super(props);

    this.state = {
      error: null,
      salesValue: 15000,
      commission: 15,
      fees: 1000,
      withOthers: 0,
      withSteppr: 0,
    };
  }

  componentDidMount() {
    const { user } = this.props;

  }


  handleChange = e => {
    const { name, value } = e.target;
    const { salesValue, fees } = this.state;

    if (name === "commission") {
      this.setState({ [e.target.name]: e.target.value });
    } else if (name === "fees") {
      if (value.match(/^[0-9]+$/) != null) {
        this.setState({ [e.target.name]: e.target.value });
      } else {
        return null;
      }
    } else if (name === "salesValue") {
      if (value.match(/^[0-9]+$/) != null) {
        this.setState({ [e.target.name]: e.target.value });
      } else {
        return null;
      }
    }
  };

  scrollToTop = () => {
    console.log('scrollToTop');
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });

    const { parentActionFunction } = this.props;

    console.log('parentActionFunction');

    if (parentActionFunction) {
      parentActionFunction();
    }
  }

  goToSignup2 = (event) => {
    const { history } = this.props;

    if (event.ctrlKey) {
      console.debug("Ctrl+click has just happened!");
    } else {
      history.push(`/signup`);
    }

    this.scrollToTop();
  }

  goToSignup = (event) => {
    const { history } = this.props;

    if (event.ctrlKey) {
      console.debug("Ctrl+click has just happened!");
    } else {
      window.open('https://app.steppr.com/signup', '_blank').focus();
    }

    // this.scrollToTop();
  }

  calculate = () => {
    const { salesValue, fees, commission } = this.state;

    const withSteppr = Math.round(salesValue, 10);
    const withOthers = Math.round((salesValue - ((commission ? (salesValue * (commission / 100)) : 0)) - (fees || 0)), 10);

    this.setState({ withSteppr, withOthers });
  }

  render() {
    const { user } = this.props;
    const {
      salesValue, fees, commission, withOthers, withSteppr,
    } = this.state;

    return (
      <>
        <section className="savings-calculator section">
          <div className="savings-calculator-wrapper">
          <ReactWOW animation='fadeInUp' delay=".4s">
              <div className="container-fluid" style={{ padding: 0 }}>

              <div className="row savings-calculator-top-section">
                  <div className="col-1 col-xs-3 col-sm-3 col-md-6 col-lg-7" />
                  <div className="col-10 col-xs-6 col-sm-6 col-md-6 col-lg-4 savings-calculator-top-section-text">
                  Voucher Sales in a Year
                </div>
              </div>

              <div className="row savings-calculator-bottom-section">
                  <div className="col-1 col-xs-1 col-sm-3 col-md-6 col-lg-7" />
                  <div className="col-10 col-xs-10 col-sm-6 col-md-6 col-lg-4">
                    <div className="savings-calculator-bottom-section-text1">Steppr v Others</div>
                    <div className="savings-calculator-bottom-section-text2">
                      See how much more you would make with us, with our sales calculator.
                    </div>
                    <div className="savings-calculator-bottom-section-text3">
                      <Button color=" primary" className="savings-calculator-bottom-section-button" onClick={(e) => { this.goToSignup(e) }}>
                        Launch with Steppr now
                      </Button>
                    </div>
                </div>
              </div>

              <div className="savings-calculator-calculator-section">
                  <div className="row">
                    <div className="col-2 col-xs-2 col-sm-3 col-md-2 col-lg-5 col-xl-7"></div>
                    <div className="col-8 col-xs-8 col-sm-6 col-md-5 col-lg-5 col-xl-4 savings-calculator-calculator">
                      <div className="row savings-calculator-calculator-top">
                        <div className="row">
                          <div className="col-12">
                            <div className="col-6 savings-calculator-calculator-title">
                              Sales Calculator
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6 savings-calculator-calculator-text">
                            Voucher Sales
                          </div>
                          <div className="col-6 savings-calculator-calculator-input">
                            <Input type="text" name="salesValue" id="salesValue" value={salesValue} onChange={this.handleChange} style={{ "-moz-appearance": "textfield", "-webkit-appearance": "none" }} />
                            <div className="savings-calculator-calculator-input-pound-sign" >{pound}</div>
                          </div>
                        </div>
                      </div>

                      <div className="row savings-calculator-calculator-bottom">
                        <div className="row">
                          <div className="col-6 savings-calculator-calculator-text">
                            <div>Fees</div>
                            <p>Other platforms, not Steppr</p>
                          </div>
                          <div className="col-6 savings-calculator-calculator-input">
                            <Input
                              type="text"
                              name="fees"
                              id="fees"
                              value={fees}
                              onChange={this.handleChange}
                              style={{ "-moz-appearance": "textfield", "-webkit-appearance": "none" }}
                            />
                            <div className="savings-calculator-calculator-input-pound-sign" >{pound}</div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6 savings-calculator-calculator-text">
                            <div>Commission</div>
                            <p>Other platforms, not Steppr</p>
                          </div>
                          <div className="col-6 savings-calculator-calculator-input savings-calculator-calculator-range-wrapper">
                            <Input min="0" max="100" step="1" type="range" name="commission" id="commission" value={commission} onChange={this.handleChange} className="savings-calculator-calculator-range" />
                            <div className="savings-calculator-calculator-range-value">
                              {`${commission}%`}
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-12 savings-calculator-calculator-what-you-make">
                            <Button color="priamry" className="savings-calculator-calculator-what-you-make-button" onClick={this.calculate}>
                              Estimate
                            </Button>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-7">
                            Earnings with Others
                          </div>
                          <div className="col-5 savings-calculator-calculator-what-you-make-steppr-value-regular">
                            {`${pound} ${numberWithCommas(withOthers)}`}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-7 savings-calculator-calculator-what-you-make-steppr">
                            Earnings with <b style={{ fontWeight: 500 }}>Steppr</b>
                          </div>
                          <div className="col-5 savings-calculator-calculator-what-you-make-steppr-value">
                            {`${pound} ${numberWithCommas(withSteppr)}`}
                          </div>
                        </div>
                      </div>

                  
                  </div>
                  <div className="col-6" />
                </div>
              </div>
            </div>
            </ReactWOW>
          </div>
        </section>
      </>
    );
  }
}

export default withRouter(SavingsCalculator);
